module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "chapter05"
    }
  }, [_c('a', {
    attrs: {
      "id": "page5"
    }
  }), _c('div', {
    staticClass: "chapterHead"
  }, [_c('a', {
    attrs: {
      "id": "page5"
    }
  }), _c('h2', {
    staticClass: "chapterTitle"
  }, [_c('a', {
    attrs: {
      "id": "page5"
    }
  }, [_c('span', {
    staticClass: "xrefInternal"
  })]), _c('a', {
    attrs: {
      "href": "#/004TOC#chapter_05"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("BUT NOW–I’LL NEVER BE PREGNANT AGAIN")])])])]), _vm._v(" "), _c('div', {
    staticClass: "chapterBody"
  }, [_c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("My biological clock")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("has ticked its last tock.")])]), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("And the finality of this fact,")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("the that’s-thatness of it,")])]), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("hollows me")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("like a gutted pumpkin")])]), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("and leaves me")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("with a sense of loss so deep")])]), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("that all I want to do")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("is sleep.")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c31f779","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/009-chapter05.vue
// module id = 84
// module chunks = 0